import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import {SGP} from "./sgp-results-react";
import Typography from "@mui/material/Typography";
import {Alert, Stack, Tabs} from "@mui/material";
import Tab from "@mui/material/Tab";
import moment from "moment-timezone";
import DayTask from "./DayTask";
import ResultTable from "./ResultTable";
import CompetitionHeader from "./CompetitionHeader";
import Autoload from "./Autoload";
import {getEventDatesString} from "../Calendar";
import DownloadEntryListWidget from "../../components/Event/DownloadEntryListWidget";

const EventResults = ({event}) => {
    const editionId = event?.id
    const [comp, setComp] = React.useState()
    const [dayIndex, setDayIndex] = React.useState()
    const [day, setDay] = React.useState()
    const [hasDayData, setHasDayData] = React.useState(false)
    const [autoloadActivated, setAutoloadActivated] = React.useState(false)
    const [autoloadInterval, setAutoloadInterval] = React.useState()
    const [autoloadExpires, setAutoloadExpires] = React.useState()
    const [intervalFn, setIntervalFn] = React.useState()
    const [lastUpdated, setLastUpdated] = React.useState()
    const [hasScoring, setHasScoring] = React.useState(true)

    useEffect(() => {
        // fetch data
        const dataFetch = async () => {
            const comp = await (
                await fetch(SGP.resultsUrl+"/c/sgp/rest/comp/"+editionId)
            ).json().catch((error) => {
                console.log('Error while fetching result data')
                console.log(error)
                setHasScoring(false)
            })

            comp.i[comp.j]=comp.d

            setComp(comp)
            setDay(comp.d)
            setHasDayData(true)
            setHasScoring(true)

            if ((comp.d.r.u>=1 && comp.j===comp.i.length-1) || comp.i[comp.i.length-1].y===3) {
                //last day of comp is official so show event classification
                setDayIndex(comp.i.length)
            }
            else if (comp.z.t) {
                setAutoloadInterval(comp.z.t * 1000)
                setAutoloadExpires(new Date().getTime() + comp.z.l * 60000)
                setAutoloadActivated(true)
                setDayIndex(comp.j)
            }
            else if (!comp.d.v && comp.j===0) {
                //no results yet for comp so show schedule
                setDayIndex(-1)
            }
        };

        dataFetch();

    }, []);

    useEffect(() => {
        if (comp && dayIndex!==undefined && dayIndex !==-1 && dayIndex!==comp.i.length) {
            if (!comp.i[dayIndex].r) {
                //we need to fetch data for this day
                setHasDayData(false)
                const dayDataFetch = async () => {
                    const day = await (
                        await fetch(SGP.resultsUrl + "/c/sgp/rest/day/" + editionId + "/" + comp.i[dayIndex].i)
                    ).json();

                    let c = comp
                    c.i[dayIndex] = day
                    setComp(c)
                    setDay(day)
                    setHasDayData(true)
                };

                dayDataFetch()
            }
            else {
                setDay(comp.i[dayIndex])
                setHasDayData(true)
            }
        }


    },[dayIndex])

    const disableAutoload = () => {
        if (intervalFn) {
            console.log("unmounting autoload")
            clearInterval(intervalFn)
            setIntervalFn(undefined)
        }
    }

    useEffect(() =>{
        if (autoloadActivated) {
            //enable autoload
            if (intervalFn) disableAutoload()

            console.log(`mounting autoload with expiration ${moment(autoloadExpires).format()} and interval ${autoloadInterval/1000} sec`)
            setIntervalFn( setInterval(async () => {
                console.log('autoload exec')

                if (new Date().getTime() > autoloadExpires) {
                    //auto polling has expired, so finish autoload
                    console.log("Autoload has expired")
                    setAutoloadActivated(false)
                }
                else {
                    //do polling

                    const newComp = await (
                        await fetch(SGP.resultsUrl+"/c/sgp/rest/comp/auto/"+comp.c.i+"/"+comp.c.v)
                    ).json();

                    if (newComp.v===2) {
                        newComp.i=comp.i
                        newComp.i[newComp.j]=newComp.d


                        if (dayIndex===newComp.j || dayIndex===newComp.j+1) {
                            setDay(newComp.d)
                            setHasDayData(true)
                        }
                        else {
                            setComp(newComp)
                        }

                        if (newComp.z.t===0) {
                            setAutoloadActivated(false)
                        }
                    }

                    setLastUpdated(new Date());
                }

            }, autoloadInterval))
        }
        else {
            //disable autoload
            disableAutoload()
        }


        return () => {
            disableAutoload()
        }
    },[autoloadActivated])

    const handleDayChange = (evt, value) => {
        setDayIndex(value)
    }

    const daySelector = (comp,dayIndex) => {
        let hasValidDays=false;

        return (
            <Box sx={{}}>
                <Tabs
                    value={dayIndex}
                    onChange={handleDayChange}
                    aria-label="Day selector"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab
                        value={-1}
                        key={'schedule'}
                        label={
                            <Stack>
                                <Typography variant="caption" sx={{}}>
                                    &nbsp;
                                </Typography>
                                <Typography variant="title">
                                    Schedule
                                </Typography>
                            </Stack>
                        }
                        sx={{
                            textTransform:'none',
                            minWidth:0,
                        }}
                    />
                    {
                        comp.i.map((day,i) =>{
                            if (day.v && day.y===1) hasValidDays=true
                            return (
                                <Tab label={
                                    <Stack>
                                        <Typography variant="caption" sx={{}}>
                                            {moment(day.d).format('ddd D/M')}
                                        </Typography>
                                        <Typography variant="title"  sx={{}}>
                                            {day.l}
                                        </Typography>
                                    </Stack>

                                }
                                     value={i}
                                     key={i}
                                     disabled={!(day.v)}
                                     sx={{
                                         textTransform:'none',
                                         minWidth:0,
                                     }}
                                />
                            )
                        })
                    }
                    <Tab
                        value={comp.i.length}
                        label={
                            <Stack>
                                <Typography variant="caption" sx={{}}>
                                    &nbsp;
                                </Typography>
                                <Typography variant="title">
                                    Total
                                </Typography>
                            </Stack>
                        }
                        key={'total'}
                        sx={{
                            textTransform:'none',
                            minWidth:0,
                        }}
                    />
                </Tabs>
            </Box>
        )

    }

    const autoload= autoloadActivated && <Autoload lastUpdated={lastUpdated}/>

    return (
        <Box my={2}>
            {
                comp &&
                <>
                    <Box sx={{
                        display:'flex',
                        alignItems:'center',
                        //justifyContent:'space-between',
                        my:'1em',
                        columnGap:'2em',
                    }}>
                        <Typography variant={'h2'} flexGrow={1} textAlign={'left'}>Results</Typography>
                    </Box>
                    {comp.c.u!==40 && daySelector(comp,dayIndex)}
                    <CompetitionHeader comp={comp} dayIndex={dayIndex} autoload={autoload}/>
                    {comp.c.u===40 &&
                        <Box py={10} my={2} sx={{bgcolor:'#f0f0f0'}} align={'center'}>
                            <Typography variant={'body1'}>NO RESULTS YET</Typography>
                        </Box>
                    }
                    {comp.c.u!==40 && dayIndex!==-1 && dayIndex!==comp.i.length &&
                        <>
                            {
                                hasDayData &&
                                <>
                                    <DayTask day={day} disableAutoload={disableAutoload}/>
                                    <ResultTable comp={comp} day={day} dayIndex={dayIndex}/>
                                </>
                            }
                        </>
                    }
                    {comp.c.u!==40 && (dayIndex===-1 || dayIndex===comp.i.length) &&
                        <ResultTable comp={comp} day={day} dayIndex={dayIndex}/>
                    }
                </>
            }
            {!hasScoring &&
                <>
                    <Box sx={{
                        display:'flex',
                        alignItems:'center',
                        //justifyContent:'space-between',
                        my:'1em',
                        columnGap:'2em',
                    }}>
                        <Typography variant={'h2'} flexGrow={1} textAlign={'left'}>Results</Typography>
                    </Box>
                    <Box sx={{textAlign:'left',bgcolor:'#113248',color:'#ffffff'}} mb={3} p={2}>
                        <Stack direction={'row'}>
                            <Box mr={'24px'}>
                                <img src='/etc/img/sgp-series-logo-v3.png' alt="SGP" style={{width:'160px'}}/>
                            </Box>
                            <Box>
                                <Typography variant={'h5'}>{SGP.getChampionshipTitle(event)}</Typography>
                                <Typography variant={'h5'}>{event.fullEditionTitle}</Typography>
                                <Typography variant={'h6'}>{event.venue}</Typography>
                                <Typography variant={'h6'}>{getEventDatesString(event)}</Typography>
                            </Box>
                        </Stack>
                    </Box>
                    <Alert severity={'info'}>No results yet</Alert>
                </>
            }
        </Box>
    );
};

export default EventResults;